import Client from './client';

export default class ClassificationActions extends Client {
  constructor(opts) {
    let options = opts;

    if (typeof opts === 'string') {
      options = { host: opts }; // convert host string to options object
    }

    options.serviceName = 'API Internal';

    super(options);
  }

  get(options = {}) {
    return this.makeRequest(`${this.host}/classification/actions`, options);
  }

  put(options = {}) {
    return this.makeRequest(`${this.host}/classification/actions`, {
      ...options,
       method: 'PUT',
    });
  }

}
